<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="BdrFws_1d01_P20 3er Kaskade"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import BdrFws_1d01_P20 from '@/device-products/BdrFws_1d01_P20.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'KB',
        connections: [
            {
                id: 'Station 1 zu Station 2',
                from: { deviceId: 0, uart: 1},
                to: { deviceId: 1, uart: 1},
            } 
            ]
      },
      {
        label: 'KB',
        connections: [
            {
                id: 'Station 1 zu Station 3',
                from: { deviceId: 0, uart: 1},
                to: { deviceId: 2, uart: 1},
            } 
            ]
      },
          ],
    simulationDevices: [
      { id: 0, component: BdrFws_1d01_P20, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } }, // swapped after FWR2018
      { id: 1, component: BdrFws_1d01_P20, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } },
      { id: 2, component: BdrFws_1d01_P20, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } },
    ],
  }),
};
</script>

<style>

</style>
